import { Logger } from '~/lib/logger';
import { useAuth } from '~/providers/AuthProvider';

const logger = new Logger('B2C Document Hook');

export const useB2CDocument = () => {
  const { token, logout } = useAuth();

  /**
   * Fetches a document from the given path
   * @param documentPath - the path to the document to fetch
   * @returns the document data promise
   */
  const fetchDocument = async (documentPath: string): Promise<string> => {
    const response = await fetch(documentPath, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      // If the request is unauthorized, the user will be redirected to the login page via the RequireAuth component
      if (response.status === 401) {
        logger.error('Unauthorized request');
        logout();
      }

      throw new Error('Failed to fetch Orders data');
    }

    return await response.json();
  };

  return { fetchDocument };
};
